module.exports = __webpack_public_path__ + "static/media/generalhealth-intro.afa7e985.svg";